import React, { useState } from "react";
import "./IntegrationBenefit.css";
import img1 from '../integrationassets/Union.png';
import img2 from '../integrationassets/union2.png';
import img3 from '../integrationassets/union3.png';
import img4 from '../integrationassets/union4.png';
import img5 from '../integrationassets/union5.png';
import img6 from '../integrationassets/union6.png';

export default function IntegrationBenefit() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
        img:img1,
      id: 1,
      title: "Azure DevOps Automated Testing",
      description:
        "Streamline your Azure DevOps infrastructure by automating CI/CD pipelines and running continuous tests right from the start of the software development lifecycle",
        bg:"#FFF4E6"
    },
    {
         img:img2,
      id: 2,
      title: "AWS Automated Testing Process",
      description:
        "Integrate your AWS DevOps development process with best-in-class automation tools to reduce potential bugs and create robust cloud applications",
        bg:"#E7F3FF"
    },
    {
         img:img3,
      id: 3,
      title: "Build-Deployment Automation",
      description:
        "Cut down the scope of human intervention so that you can decrease the number of possible errors by thoroughly automating your build and deployment process",
        bg:"#F7EBFF"
    },
    {
         img:img4,
      id: 4,
      title: "DevOps Workflow Automation",
      description:
        "Embrace DevOps automation best practices and strategies to facilitate an efficient workflow in your business and reduce manual, time-consuming workload",
        bg:"#F2FBED"
    },
    {
         img:img5,
      id: 5,
      title: "DevOps Process Automation",
      description:
        "Simplify your development tasks and make the entire ecosystem faster and more productive by enabling comprehensive DevOps process automation",
        bg:"#F0ECFB"
    },
    {
         img:img6,
     id: 6,
      title: "Continuous Delivery Automation",
      description:
        "Take your deployment and release game to new heights with the required speed, agility, and reliability through a continuous delivery automation plan",
        bg:"#FEF7DB"
    },
  ];

  return (
    <div id="integration-benefit" className="outsourcemainclass">
      <div className="top">
        <h2 className="heading">
         Benefits of BastionEx CI Services
        </h2>
        <p className="subheading">
        Enabling faster software delivery, improved code quality, and seamless collaboration across development and quality assurance teams.
        </p>
      </div>
      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id} style={{backgroundColor:card.bg}}>
          <div className="content">
             <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
          <img src={card.img} alt="error" className="image"/>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id} style={{backgroundColor:card.bg}}>
                <div className="content">
                    <h3>{card.title}</h3>
                <span>{card.description}</span>
                </div>
                  <img src={card.img} alt="error" className="image"/>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
